
export const products = [
  // الأدوية
  { id: 'p1', name: 'باراسيتامول 500 مجم - 20 قرص', price: 12, categoryPage: 'medicines' },
  { id: 'p2', name: 'أموكسيسيلين 500 مجم كبسولات', price: 28, categoryPage: 'medicines' },
  { id: 'p3', name: 'شراب خافض حرارة للأطفال', price: 18, categoryPage: 'medicines' },

  // الفيتامينات
  { id: 'p4', name: 'فيتامين سي 1000 مجم فوار', price: 35, categoryPage: 'vitamins' },
  { id: 'p5', name: 'فيتامين د3 5000 وحدة', price: 42, categoryPage: 'vitamins' },
  { id: 'p6', name: 'ملتي فيتامين يومي للبالغين', price: 55, categoryPage: 'vitamins' },

  // المكملات الغذائية
  { id: 'p7', name: 'أوميجا 3 كبسولات زيت سمك', price: 65, categoryPage: 'supplements' },
  { id: 'p8', name: 'مغنيسيوم + زنك أقراص', price: 48, categoryPage: 'supplements' },

  // منتجات الأطفال
  { id: 'p9', name: 'حفاضات أطفال مقاس 3', price: 75, categoryPage: 'children-products' },
  { id: 'p10', name: 'مناديل مبللة للأطفال', price: 15, categoryPage: 'children-products' },

  // الحمل والرضاعة
  { id: 'p11', name: 'حليب صناعي للرضع', price: 120, categoryPage: 'pregnancy-motherhood' },
  { id: 'p12', name: 'كريم لعلاج تشققات الحمل', price: 60, categoryPage: 'pregnancy-motherhood' },

  // العناية بالبشرة
  { id: 'p13', name: 'غسول وجه لطيف للبشرة الحساسة', price: 45, categoryPage: 'skin-care' },
  { id: 'p14', name: 'كريم مرطب يومي بالهيالورونيك', price: 68, categoryPage: 'skin-care' },
  { id: 'p15', name: 'واقي شمس SPF 50', price: 55, categoryPage: 'skin-care' },

  // العناية بالشعر
  { id: 'p16', name: 'شامبو ضد القشرة', price: 32, categoryPage: 'hair-care' },
  { id: 'p17', name: 'سيروم لتساقط الشعر', price: 85, categoryPage: 'hair-care' },

  // العناية بالفم والأسنان
  { id: 'p18', name: 'معجون أسنان مبيض', price: 22, categoryPage: 'oral-care' },
  { id: 'p19', name: 'غسول فم مطهر', price: 25, categoryPage: 'oral-care' },

  // العناية بالعيون
  { id: 'p20', name: 'قطرة مرطبة للعين', price: 20, categoryPage: 'eye-care' },

  // الأجهزة الطبية
  { id: 'p21', name: 'جهاز قياس ضغط الدم الرقمي', price: 180, categoryPage: 'blood-pressure' },
  { id: 'p22', name: 'جهاز قياس سكر الدم مع 25 شريط', price: 210, categoryPage: 'diabetes-devices' },

  // الإسعافات الأولية
  { id: 'p23', name: 'شنطة إسعافات أولية متكاملة', price: 95, categoryPage: 'first-aid' },
  { id: 'p24', name: 'لاصق جروح طبي', price: 10, categoryPage: 'first-aid' },

  // المطهرات والمعقمات
  { id: 'p25', name: 'معقم يدين 500 مل', price: 18, categoryPage: 'sanitizers' },
  { id: 'p26', name: 'كحول طبي 70%', price: 14, categoryPage: 'sanitizers' },

  // الأعشاب الطبيعية
  { id: 'p27', name: 'شاي أعشاب للهضم', price: 25, categoryPage: 'herbs' },

  // التغذية الرياضية
  { id: 'p28', name: 'بروتين واي بروتين 1 كجم', price: 220, categoryPage: 'sports-nutrition' },

  // إنقاص الوزن
  { id: 'p29', name: 'كبسولات حرق دهون طبيعية', price: 90, categoryPage: 'weight-loss' },

  // كبار السن
  { id: 'p30', name: 'كرسي حمام لكبار السن', price: 150, categoryPage: 'elder-care' },

  // المستلزمات الطبية
  { id: 'p31', name: 'قفازات طبية معقمة (علبة 100)', price: 40, categoryPage: 'medical-supplies' },

  // الكمامات والحماية
  { id: 'p32', name: 'كمامات طبية (علبة 50)', price: 20, categoryPage: 'protection' },

  // المنتجات المميزة (نفس المنتجات المعروضة في قسم "الأكثر طلباً من عملائنا" بالصفحة الرئيسية)
  { id: 'p33', name: 'فيتامين د3 5000 وحدة - Nature Made', price: 89.99, categoryPage: 'vitamins' },
  { id: 'p34', name: 'أوميجا 3 فيش أويل - Nordic Naturals', price: 156.50, categoryPage: 'supplements' },
  { id: 'p35', name: 'مقياس ضغط الدم الرقمي - Omron', price: 299.99, categoryPage: 'blood-pressure' },
  { id: 'p36', name: 'كريم مرطب للبشرة الحساسة - CeraVe', price: 67.50, categoryPage: 'skin-care' },
  { id: 'p37', name: 'مكمل الكالسيوم والمغنيسيوم - Garden of Life', price: 134.99, categoryPage: 'supplements' },
  { id: 'p38', name: 'ميزان حرارة رقمي - Braun', price: 89.00, categoryPage: 'medical-devices' }
];

/** بترجع كل منتجات فئة معينة حسب الـ slug بتاعها */
export const getProductsByCategory = (categoryPage) =>
  products.filter((product) => product.categoryPage === categoryPage);

export default products;
